"use strict";
/**
 * Copyright 2017-present Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain
 * a copy of the license in the LICENSE and PATENTS files in the root of this
 * repository.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/** Type guard for `IPageNode`, useful for its `children` array. */
function isPageNode(node) {
    return node != null && node.children != null;
}
exports.isPageNode = isPageNode;



//////////////////
// WEBPACK FOOTER
// ./node_modules/documentalist/dist/client/markdown.js
// module id = 1302
// module chunks = 0